import type { Howl } from 'howler'

import type { IAddParams, TAudioFormat } from '../BaseSoundSystem/definitions'

export const DEFAULT_VOLUME = 1

export interface IWebAudioAddParams extends IAddParams {
  limit?: number
  readonly isOnlyPreloaded?: boolean
}

export type TTrackLimit = Record<string, number>

export type TPreloadedAudio = Record<string, Howl>

export type TPreloadedAudios = {
  [key in TAudioFormat]: TPreloadedAudio
}

export interface IFadeParams {
  /** A hangfájl kulcsa. */
  readonly key: string
  /** Lejátszás előtti „kivárás”. */
  readonly delay?: number
  /** Mennyi idő alatt menjen végbe a „halkítás/hangosítás”. */
  readonly duration: number
  /** Cél hangerő. */
  readonly to: number
  /** Kiinduló hangerő. */
  readonly from?: number
  /** Lejátszott hang azonosítója. */
  readonly id?: number
  /** Tároljuk a cél hangerőt? */
  readonly needToStoreVolume?: boolean
}

export interface IAudioSource {
  readonly src: string
  readonly volume: number
}

export type TAudioSources = Record<string, IAudioSource | 'in-progress'>

export type { IAudio, IPlayParams, TPlayingAudioData } from '../BaseSoundSystem/definitions'

export type { TAudioFormat }
